export function formatContent(content: Record<string, string>): string {
  return Object.entries(content)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');
}
